/**
 * 秒转分秒
 * @param {number} onlySecond
 */

export default function formatAudioTiming (onlySecond) {
  const duration = Math.floor(onlySecond)
  let minute = Math.floor(duration / 60)
  minute = minute < 10 ? ('0' + minute) : minute
  let second = duration % 60
  second = second < 10 ? ('0' + second) : second
  return minute + ':' + second
}



// WEBPACK FOOTER //
// ./src/utils/formatAudioTiming.js